<template>
  <div class="review">
      <div class="search">
            <el-date-picker
            style="margin-right:1%"
            v-model="startTime"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="提交日期">
            </el-date-picker>
        <span class="demonstration" style="line-height: 38px;font-size: 14px;">至</span>
            <el-date-picker
            style="margin-left:1%"
            v-model="endTime"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="提交日期">
            </el-date-picker>
          <el-input v-model="orderid" placeholder="订单号"></el-input>
          <el-input v-model="name" placeholder="客户姓名"></el-input>
          <el-input v-model="carnum" placeholder="车架号"></el-input>
          <el-input v-model="compay" placeholder="金融公司"></el-input>
          <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
      </div>
      <div class="tablelist">
          <el-table
            :data="tableData"
            :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
            style="width: 100%">
            <el-table-column
                prop="saleCode"
                label="订单号"
                width="200">
            </el-table-column>
            <el-table-column
                prop="name"
                width="150"
                label="车主姓名">
            </el-table-column>
            <el-table-column
               width="150"
                prop="phone"
                label="手机号">
            </el-table-column>
            <el-table-column
               width="150"
                prop="carModelOne"
                label="汽车车型">
                <template slot-scope="scope">
                    {{scope.row.carModelOne+scope.row.carModelTwo}}
                </template>
            </el-table-column>
            <el-table-column
               width="150"
                prop="vin"
                label="车架号">
            </el-table-column>
            <el-table-column
               width="150"
                prop="productName"
                label="产品名称">
            </el-table-column>
            <el-table-column
               width="150"
                prop="saleType"
                label="订单类型">
                <template slot-scope="scope">
                    {{scope.row.saleType == 1 ?'销售':scope.row.saleType == 2?'续费':'销售'}}
                </template>
            </el-table-column>
            <el-table-column
                prop="submitDate"
                label="提交日期">
            </el-table-column>
            <el-table-column
                prop=""
                label="操作">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="look(scope.row)">查看</el-link>
                    <el-link :underline="false" @click="draft(scope.row)" v-if="scope.row.saleType == 1 ">转草稿</el-link>
                    <el-link :underline="false" @click="deletes(scope.row)" v-if="scope.row.saleType == 2 " style="color:#F56C6C">删除</el-link>
                </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="page">
          <el-pagination
            :background="true"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
      </div>
  </div>
</template>

<script>
import {getselllist,transfer2draft,deleteCode} from '../axios/api'
export default {
    data(){
        return{
            orderid:'',
            name:'',
            carnum:'',
            compay:'',
            value2: '',
            tableData:[],
            currentPage4: 1,
            total:0,
            page:1,
            startTime:'',
            endTime:'',
            states:0
        }
    },
    created(){
        this.getdata()
    },
    methods:{
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.page = val
            if(this.states == 0){
                this.getdata()
            }else{
                this.search1()
            }
            
        },
        look(row){
            this.$router.push({
                name:'订单详情',
                params:{
                    code:row.saleCode,
                    id:row.id
                }
            })
        },
        draft(row){
            console.log(row)
            this.$confirm('是否转到草稿箱?', '转草稿', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                 closeOnClickModal:false,
                type: 'warning'
                }).then(async () => {
                    var {data:dt} = await transfer2draft({
                        id:row.saleId
                    })
                    console.log(dt)
                    if(dt.code == 200){
                        this.$message({
                            type: 'success',
                            message: '转至草稿箱成功'
                        });
                        this.getdata()
                    }else{
                        this.$message.error(dt.message)
                    }
                    
                }).catch(() => {
                
            });
        },
        async getdata(){
            this.states = 0
            var {data:dt} = await getselllist({
                current:this.page,
                limit:10,
                state:6,
                shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.total = dt.data.page.total
                this.tableData = dt.data.page.records
            }
        },
        async search(){
            this.states = 1
            var {data:dt} = await getselllist({
                startSubmitDate:this.startTime,
                endSubmitDate:this.endTime,
                code:this.orderid,
                name:this.name,
                vin:this.carnum,
                financialCompany:this.compay,
                state:6,
                current:1,
                limit:10,
                 shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.page = 1
                this.total = dt.data.page.total
                this.tableData = dt.data.page.records
            }
        },
        async search1(){
            this.states = 1
            var {data:dt} = await getselllist({
                startSubmitDate:this.startTime,
                endSubmitDate:this.endTime,
                code:this.orderid,
                name:this.name,
                vin:this.carnum,
                financialCompany:this.compay,
                state:6,
                current:this.page,
                limit:10,
                 shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.total = dt.data.page.total
                this.tableData = dt.data.page.records
            }
        },
        deletes(row){
            console.log(row)
            this.$confirm('确认删除订单，删除后数据无法恢复?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                 closeOnClickModal:false,
                type: 'warning'
                }).then(async () => {
                    var {data:dt} = await deleteCode({
                        code:row.saleCode
                    })
                    console.log(dt)
                    if(dt.code == 200){
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getdata()
                    }else{
                        this.$message.error(dt.message)
                    }
                    
                }).catch(() => {
                
            });
        }
    }
}

</script>
<style lang="less" scoped>
.review{
   background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .tablelist{
        margin-top: 15px;
        .el-link.el-link--default {
            color: #409eff;
            margin-right: 12px;
        }
    } 
}
</style>
<style>
.el-date-range-picker{
        z-index: 9999999!important;
}
.el-date-range-picker__editors-wrap .el-date-range-picker__time-picker-wrap:nth-child(2){
    display: none;
    /* display: ; */
}
</style>